export const LOCALHOST = 'localhost';
export const LA_SEXTA = 'lasexta';
export const ANTENA3 = 'antena3';
export const ONDACERO = 'ondacero';
export const LA_RAZON = 'larazon';
export const SITES = [ANTENA3, LA_SEXTA, ONDACERO, LA_RAZON];
export const sitesNotExcluded = [ONDACERO];

export const DEFAULT_SITE = ANTENA3;

export const isOndaCero = site =>
  site === ONDACERO || window.location.hostname.includes(ONDACERO);

export const isAntena3 = site =>
  site === ANTENA3 || window.location.hostname.includes(ANTENA3);

export const isLaSexta = site =>
  site === LA_SEXTA || window.location.hostname.includes(LA_SEXTA);

export const isLaRazon = site =>
  site === LA_RAZON || window.location.hostname.includes(LA_RAZON);

export const getSite = () => {
  if (window.location.hostname.includes(ONDACERO)) {
    return ONDACERO;
  }
  if (window.location.hostname.includes(LA_SEXTA)) {
    return LA_SEXTA;
  }
  if (window.location.hostname.includes(LA_RAZON)) {
    return LA_RAZON;
  }
  if (window.location.hostname.includes(ANTENA3)) {
    return ANTENA3;
  }
  return DEFAULT_SITE;
};

export const customAcronym = (partyFormat, site) => {
  if (partyFormat?.partyAcronym == 'C') {
    return partyFormat.originalPartyAcronym;
  }
  if (
    partyFormat?.id == 57 ||
    partyFormat?.partyAcronym == 'JUNTS' ||
    partyFormat?.laSextaAcronym == 'JUNTS'
  ) {
    return partyFormat.originalPartyAcronym || 'JUNTS';
  }
  if (isLaSexta(site)) {
    return (
      partyFormat.laSextaAcronym ||
      partyFormat.partyAcronym ||
      partyFormat.originalPartyAcronym
    );
  }
  if (isAntena3(site) || isOndaCero(site)) {
    return (
      partyFormat.a3Acronym ||
      partyFormat.partyAcronym ||
      partyFormat.originalPartyAcronym
    );
  }

  if (isLaRazon(site)) {
    return (
      partyFormat.laRazonAcronym ||
      partyFormat.partyAcronym ||
      partyFormat.originalPartyAcronym
    );
  }

  return partyFormat.partyAcronym || partyFormat.originalPartyAcronym;
};
export const customColor = (partyFormat, site) => {
  if (partyFormat?.id == 78) {
    return '#6A1F5F';
  }

  if (partyFormat?.partyAcronym == 'C') {
    return '#b86fc8';
  }

  if (isLaSexta(site)) {
    return partyFormat.laSextaColor || partyFormat.partyColor;
  }
  if (isAntena3(site) || isOndaCero(site) || isLaRazon(site)) {
    return partyFormat.a3Color || partyFormat.partyColor;
  }
  return partyFormat.partyColor;
};
